/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.groupModule', ['focus-if', 'lodash', 'mm.foundation', 'ui.router', 'bulbApp.ajaxModule',
  'bulbApp.authModule', 'bulbApp.busyModule', 'bulbApp.configModule', 'bulbApp.errorModule',
  'bulbApp.modalModule', 'bulbApp.translateModule'])

  .constant('GROUP', {
    PAGE_SIZE: 18,
  })
  .run(['$rootScope', 'GROUP', ($rootScope, GROUP) => {
    // eslint-disable-next-line no-param-reassign
    $rootScope.GROUP = GROUP;
  }])

  .config(['$stateProvider', ($stateProvider) => {
    $stateProvider
      .state('createGroup', {
        parent: 'root',
        url: '^/b/group/create',
        views: {
          content: {
            template: '<bulb-group-create></bulb-group-create>',
          },
        },
        bulbAuth: {
          isAuthorized: ['BulbAuthService', (BulbAuthService) => BulbAuthService.currentUser.canCreate('Group')],
        },
      })
      .state('group', {
        parent: 'root',
        url: '^/g/{groupUrl:pathVariable}?welcome',
        resolve: {
          groupDTO: [
            '$stateParams',
            'Restangular',
            'BulbBusyService',
            ($stateParams, Restangular, BulbBusyService) => BulbBusyService.showBusyDuring(
              Restangular.one('groups', $stateParams.groupUrl).get(),
            ),
          ],
          $title: ['groupDTO', (groupDTO) => groupDTO.name],
        },
        views: {
          content: {
            templateUrl: 'ajs/components/group/group.html',
            controller: 'GroupController as groupCtrl',
          },
        },
        onEnter: ['BulbAuthService', 'RecordEventService',
          function onEnter(BulbAuthService, RecordEventService) {
            const userPrefs = BulbAuthService.currentUser.prefs;
            const groupViewOption = userPrefs.useTileViewGroupContent ? 'tile' : 'list';
            if (userPrefs.useTileViewGroupContent === true || userPrefs.useTileViewGroupContent === false) {
              RecordEventService.recordEvent('view_group', 'view_option', groupViewOption);
            } else {
              RecordEventService.recordEvent('view_group', 'view_option', 'not_set');
            }
          }],
      });
  }]);
